import { useQuery } from "react-query";
import { getDealer } from "../requests/getDealer";

export default function useGetDealer(dealerId: string) {
  return useQuery({
    queryKey: ["dealer", { dealerId }],
    queryFn: () => getDealer(dealerId),
    refetchOnWindowFocus: false,
    enabled: Boolean(dealerId),
  });
}
